import { render, staticRenderFns } from "./CapacityCard.vue?vue&type=template&id=0f84c85e&scoped=true&"
import script from "./CapacityCard.vue?vue&type=script&lang=js&"
export * from "./CapacityCard.vue?vue&type=script&lang=js&"
import style0 from "./CapacityCard.vue?vue&type=style&index=0&id=0f84c85e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f84c85e",
  null
  
)

export default component.exports